import * as R from "ramda";
import React, { Component, Fragment } from "react";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../modules/custom/customTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import MasterCOAModifying from "./components/MasterCOAModifying";
import Api from "../../../Services/Api";
import {
  flattenFormGroupObject,
  getValueFromArrayDDL,
  mapToDDL,
  mapToObjectDDL,
} from "../../common/mapper";
import { formGroup, tableColumns } from "./config/config";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import { getValueItemFromArrayDDL } from "./util";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { contructQueryParam, fetchDataAsync } from "../../../Services/Utils";
import { HttpStatus } from "../../common/Constants";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";

class MasterCOA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      alertVisible: false,
      modifyingVisible: false,
      warningVisible: false,
      successVisible: false,
      copyVisible: false,
      textError: null,
      warningMessage: null,
      warningAction: null,
      warningCopy: null,
      dataCabang: [],
      tableColumns: [
        ...tableColumns.mainPage,
        {
          name: "",
          label: "Action",
          options: {
            customBodyRender: (val, tableMeta) => {
              const menuAccess = this.props.menuAccess[0]
              return (
                <FlexView vAlignContent="center" style={{ gap: 10 }}>
                  <ToggleButton
                    value={R.equals(
                      this.state.dataTable[tableMeta.rowIndex].status,
                      "ACTIVE"
                    )}
                    onToggle={() =>
                      this.handleToggleClick(
                        tableMeta.rowIndex,
                        tableMeta.rowData
                      )
                    }
                  />
                  {menuAccess?.updateAccess && 
                    <SimpleButton
                      category="action_button"
                      style={{ backgroundColor: "transparent" }}
                      icon={
                        <i
                          style={{ fontSize: 20, color: "red" }}
                          className="fa fa-lw fa-pencil-alt"
                        />
                      }
                      onClick={() =>
                        this.handleModifyingModalVisibility(tableMeta.rowIndex)
                      }
                    />
                  }
                  {menuAccess?.createAccess &&
                    <SimpleButton
                      category="action_button"
                      style={{ backgroundColor: "transparent" }}
                      icon={
                        <i
                          style={{ fontSize: 20, color: "red" }}
                          className="fa fa-copy"
                        />
                      }
                      onClick={() =>
                        this.handleClickCopy(tableMeta.rowIndex)
                      }
                    />
                  }
                  {menuAccess?.deleteAccess &&
                    <SimpleButton
                      category="action_button"
                      className="btnAct margin-left-15px"
                      onClick={() =>
                        this.handleShowAlert(
                          this.state.dataTable[tableMeta.rowIndex].coaId
                        )
                      }
                      icon={
                        <i
                          className="fa fa-trash"
                          style={{
                            backgroundColor: "transparent",
                            color: "red",
                            fontSize: 20,
                          }}
                        />
                      }
                    />
                  }
                </FlexView>
              );
            },
            sort: false,
          },
        },
      ],
      selectedData: null,
      selectedRowIndex: null,
      payload: null,
      dataTable: [],
      pagination: {
        count: 0,
        limit: 5,
        page: 0,
        orderBy: "id",
        sort: "ASC",
      },
      alertCannotDelete: false,
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.fetchData();
    this.fetchDataCabang();
    this.handleTriggerLoading();
  };

  fetchDataCabang = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: res.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleModifyingModalVisibility = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedData: !R.isNil(index) ? prevValue.dataTable[index] : null,
      modifyingVisible: !prevValue.modifyingVisible,
    }));
  };

  handleWarningModalVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      warningVisible: !prevValue.warningVisible,
    }));
  };

  handleToggleClick = async (rowIndex, data) => {
    let currentStatus = this.state.dataTable[rowIndex].status;

    if (currentStatus == "INACTIVE") {
      this.setState((prevValue) => ({
        ...prevValue,
        warningVisible: !prevValue.warningVisible,
        warningAction: "updateStatus",
        selectedRowIndex: rowIndex,
      }));
    } else {
      this.setState(
        (prevValue) => ({
          ...prevValue,
          selectedRowIndex: rowIndex,
        }),
        () => this.handleChangeStatus()
      );
    }
  };

  handleSaveClick = (payload) => {
    this.setState(
      (prevValue) => ({
        ...prevValue,
        warningAction: "save",
        payload: payload,
      }),
      () => this.handleSubmit()
    );
  };

  handleClickCopy = async (index) => {
    const selectedData = this.state.dataTable[index];
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterCOAById,
      menuName: "Master COA",
      setError: this.props.setError,
      args: contructQueryParam({ coaId: selectedData?.coaId }),
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data;

      const masterCoaCabangDTOS = data?.masterCoaCabangDTOS?.map((item) =>
        mapToObjectDDL(item.namaCabang, item.kodeCabang)
      );

      this.setState((prev) => ({
        ...prev,
        copyVisible: true,
        errorMessage: null,
        errorMessageBranch: null,
        dataDetail: data,
        copyFormValues: {
          coaName: data.coaName || "",
          masterCoaCabangDTOS: masterCoaCabangDTOS || [],
        },
      }));
    }
  };

  handleCopyModalVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      copyVisible: !prevValue.copyVisible,
    }));
  };

  handleCopy = async (e) => {
      e.preventDefault();
      const { dataDetail, copyFormValues } = this.state;

      if (!copyFormValues.coaName) {
          this.setState((prevValue) => ({
              ...prevValue,
              errorMessage: "Field belum diisi",
              loading: false,
          }));
          return;
      } else if (!copyFormValues.masterCoaCabangDTOS) {
          this.setState((prevValue) => ({
              ...prevValue,
              errorMessageBranch: "Field belum diisi",
              loading: false,
          }));
          return;
      } else {
          const payload = {
              coaId: null,
              coaName: copyFormValues.coaName || "",
              status: dataDetail?.status || "ACTIVE",
              masterCoaDetailDTOS: (dataDetail?.masterCoaDetailDTOS || []).map(
                  (item, idx) => ({
                      id: null,
                      coaId: null,
                      coaDetailId: `TRX${String(idx + 1).padStart(3, "0")}`,
                      transactionType: item.transactionType || null,
                      category: item.category?.value || item.category || null,
                      subGroup: item.subGroup?.key || item.subGroup || null,
                      group: item.group?.key || item.group || null,
                      status: item.status || "ACTIVE",
                  })
              ),
              masterCoaCabangDTOS: (copyFormValues.masterCoaCabangDTOS || []).map(
                  (item) => ({
                      coaId: null,
                      coaCabangId: null,
                      kodeCabang: item.value,
                  })
              ),
          };

           this.setState({
              payload: payload,
              warningCopy: 'copy',
           }, () => this.handleSubmit());
      }
  };


 handleSubmit = async () => {
    const { warningAction, warningCopy } = this.state;

    if (warningAction === "save" || warningCopy === "copy") {
      await this.handleSubmitModifying();
    } 
  };

  handleSubmitModifying = async () => {
    this.handleTriggerLoading();
    const newData = {
      ...this.state.payload,
      affliiateOtherCabang: false,
    };
  
    let res = await this.callApi(
      Api.create("NAGAMAS_MASTER_DATA").saveMasterCOA,
      newData
    );

    if (res?.data?.code === 201) {
          this.setState({
              copyVisible: false,
              warningVisible: false,
              modifyingVisible: false,
              errorMessage: null,
              errorMessageBranch: null,
          });
          // this.handleRefreshPagination()
          await this.fetchData({
            limit: this.state.pagination.limit,
            page: this.state.pagination.page
          });
      } else if (res?.data?.code === 503) {
          this.setState({
              warningCopy: 'copy',
              warningAction: 'save',
              copyVisible: false,
              errorMessage: null,
              textError: res.data.message
          }, () => this.handleWarningModalVisibility());
          
      } else {
          // this.setState({ errorMessage: res?.data?.message || "Terjadi kesalahan" });
      }
  
    this.handleTriggerLoading();
  };

   handleSaveUpdate = async () => {
      this.handleTriggerLoading();
      const newData = {
        ...this.state.payload,
        affliiateOtherCabang: true,
      };

      let res = await this.callApi(
        Api.create("NAGAMAS_MASTER_DATA").saveMasterCOA,
        newData
      );

      if (res?.data?.code === 201) {
          this.setState({
              copyVisible: false,
              warningVisible: false,
              modifyingVisible: false,
              errorMessage: null,
              errorMessageBranch: null,
          });
          // this.handleRefreshPagination()
          await this.fetchData({
            limit: this.state.pagination.limit,
            page: this.state.pagination.page
          });
      }

      this.handleTriggerLoading();
    };


  handleChangeStatus = async () => {
    this.handleTriggerLoading();
    const { selectedRowIndex, dataTable } = this.state;
    const currentStatus = dataTable[selectedRowIndex]?.status;
    const newStatus = currentStatus === "ACTIVE" ? "INACTIVE" : "ACTIVE";

    let data = dataTable[selectedRowIndex];
    let requestPayload = {
      coaId: data.coaId,
      status: newStatus,
    };

    let res = await this.callApi(
      Api.create("NAGAMAS_MASTER_DATA").updateStatusMasterCOA,
      requestPayload
    );
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      if (currentStatus === "INACTIVE") {
        this.handleWarningModalVisibility()
        this.handleConfirmSuccessModalVisibility();
      } else {
        // this.handleRefreshPagination()
        await this.fetchData({
          limit: this.state.pagination.limit,
          page: this.state.pagination.page
        });
      }
    }
    this.handleTriggerLoading();
  };

  handleConfirmSuccessModalVisibility = async () => {
    this.setState((prevValue) => ({
      ...prevValue,
      successVisible: !prevValue.successVisible,
    }));
  };

  refetch = async () => {
    this.setState((prevValue) => ({
      ...prevValue,
      successVisible: !prevValue.successVisible,
    }));
    // this.handleRefreshPagination()
    await this.fetchData({
      limit: this.state.pagination.limit,
      page: this.state.pagination.page
    });
  };

  handleChangePage = async (tableState) => {
    this.handleTriggerLoading();
    const limit = tableState.rowsPerPage;
    const page = tableState.page;

    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page,
        limit,
      },
    }));

    await this.fetchData({
      page,
      limit,
    });

    this.handleTriggerLoading();
  };

  handleChangeRowsPerPage = async (tableState) => {
    this.handleTriggerLoading();
    const limit = tableState.rowsPerPage;

    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        // count: 0,
        page: 0,
        limit,
      },
    }));

    await this.fetchData({
      page: 0,
      limit,
    });

    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchData = async (body) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: { ...prevValue.pagination, count: 0 },
    }));

    const req = body || {
      page: 0,
      limit: 5,
    };

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterCOA,
      menuName: "Master COA",
      setError: this.props.setError,
      args: req,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
        pagination: {
          ...prevValue.pagination,
          count: res.data.totalData,
          page: req.page,
          limit: req.limit,
        },
      }));
    }
  };

  callApi = async (api, args) => {
    return await fetchDataAsync({
      asyncFn: api,
      menuName: "Master COA",
      setError: () => {},
      args: args,
    });
  };

  handleShowAlertCannotDelete = () => {
    this.setState((prevValue) => ({...prevValue, alertCannotDelete: !prevValue.alertCannotDelete}));
  };

  handleSubmitDelete = async () => {
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    let res = await Api.create("NAGAMAS_MASTER_DATA").deleteMasterCOA(
      this.state.deleteId
    );
    this.handleShowAlert();
    // this.handleRefreshPagination()
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      await this.fetchData({
        limit: this.state.pagination.limit,
        page: this.state.pagination.page
      });
    }
    if (res.data.code === 509) {
      this.handleShowAlertCannotDelete();
    }
  };

  handleShowAlert = (id) => {
    if (id) {
      this.setState((prevValue) => ({
        ...prevValue,
        deleteId: id,
        alertVisible: true,
      }));
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        deleteId: "",
        alertVisible: false,
        loading: false,
      }));
    }
  };

  handleRefreshPagination=()=>{
      this.setState((prevState) => ({
        ...prevState,
        pagination: {
          count: 0,
          limit: 5,
          page: 0,
        },
      }));
    }

  render() {
    
    return (
      <Container>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableColumns}
          toCount={this.state.pagination.count}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page}
          options={defaultTableChange(
            (tableState) => this.handleChangePage(tableState),
            (tableState) => this.handleChangeRowsPerPage(tableState)
          )}
          footerAdditionalButtons={
            this.props.menuAccess?.[0]?.createAccess && (
              <SimpleButton
                onClick={() => this.handleModifyingModalVisibility()}
                icon={<i className="fa fa-plus margin-right-10px"></i>}
                text={"Tambah"}
              />
            )
          }
        />

        {this.state.alertVisible && (
          <SimpleAlert
            visible={this.state.alertVisible}
            onClickClose={() => this.handleShowAlert()}
            content={"Apakah anda yakin ingin menghapus COA ini ?"}
            additionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton secondary onClick={() => this.handleShowAlert()}>
                  Batal
                </SimpleButton>
                <SimpleButton onClick={() => this.handleSubmitDelete()}>
                  Iya
                </SimpleButton>
              </FlexView>
            }
          />
        )}

        {this.state.modifyingVisible && (
          <MasterCOAModifying
            {...this.props}
            formGroup={formGroup}
            initialValues={this.state.selectedData}
            visible={this.state.modifyingVisible}
            onSubmit={this.handleSaveClick}
            onClickClose={this.handleModifyingModalVisibility}
          />
        )}

        {this.state.warningVisible && (
          <SimpleAlert
            title="Konfirmasi"
            content={
              this.state.warningAction === "updateStatus"
                ? "Proses ini akan menonaktifkan COA yang sedang aktif. Apakah anda yakin?"
                : this.state.textError
            }
            additionalButtons={
              <Fragment>
                <FlexView>
                  <SimpleButton
                    text="Iya"
                    onClick={() =>
                      this.state.warningAction === "updateStatus"
                        ? this.handleChangeStatus()
                        : this.handleSaveUpdate()
                    }
                  />
                  <SimpleButton
                    text="Tidak"
                    secondary
                    onClick={this.handleWarningModalVisibility}
                  />
                </FlexView>
              </Fragment>
            }
            visible={this.state.warningVisible}
            onClickClose={this.handleWarningModalVisibility}
          />
        )}

        {this.state.successVisible && (
          <SimpleAlert
            title={"Informasi"}
            content={"COA berhasil diaktifkan"}
            additionalButtons={
              <Fragment>
                <FlexView>
                  <SimpleButton text="OK" onClick={() => this.refetch()} />
                </FlexView>
              </Fragment>
            }
            visible={this.state.successVisible}
            onClickClose={this.handleConfirmSuccessModalVisibility}
          />
        )}

        {this.state.copyVisible && (
          <SimpleModal
            visible={this.state.copyVisible}
            onClickClose={() => this.handleCopyModalVisibility()}
            content={
              <ModalContainer>
                <form onSubmit={this.handleCopy}>
                  <SimpleInput
                    id="select_options_coaName"
                    name="coaName"
                    label="Nama COA"
                    mandatory
                    errorMessage={this.state.errorMessage}
                    value={this.state.copyFormValues?.coaName || ""}
                    onChange={({ target }) =>
                      this.setState((prev) => ({
                        ...prev,
                        copyFormValues: {
                          ...prev.copyFormValues,
                          coaName: target.value,
                        },
                        errorMessage: target.value ? null : prev.errorMessage,
                      }))
                    }
                  />
                  <SimpleDDL
                    id="select_options_kodeCabang"
                    name="masterCoaCabangDTOS"
                    label="Cabang Berlaku"
                    box="multiselect"
                    mandatory
                    errorMessage={this.state.errorMessageBranch}
                    options={(this.state.dataCabang || []).map((item) =>
                      mapToDDL(item.namaDealer, item.kodeCabang)
                    )}
                    value={this.state.copyFormValues?.masterCoaCabangDTOS || []}
                    onChange={(value) =>
                      this.setState((prev) => ({
                        ...prev,
                        copyFormValues: {
                          ...prev.copyFormValues,
                          masterCoaCabangDTOS: value,
                        },
                        errorMessageBranch: value?.length > 0 ? null : prev.errorMessageBranch,
                      }))
                    }
                  />
                  <div style={{ textAlign: "center" }}>
                    <SimpleButton type="submit">SIMPAN</SimpleButton>
                  </div>
                </form>
              </ModalContainer>
            }
          />
        )}
        {this.state.alertCannotDelete && (
          <SimpleAlert
            visible={this.state.alertCannotDelete}
            onClickClose={() => this.handleShowAlertCannotDelete()}
            content={
              <div>
                <p>Data tidak dapat dihapus, sudah masuk kedalam transaksi.</p>
              </div>
            }
            additionalButtons={
              <FlexView vAlignContent="center" style={{gap: "10px"}}>
                <SimpleButton onClick={() => this.handleShowAlertCannotDelete()}>
                  OK
                </SimpleButton>
              </FlexView>
            }/>
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};
const mapStateToProps = (state) => {
    return {
        user: state.user,
        auth: state.auth,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MasterCOA);
